import { render } from "./FCInfo.vue?vue&type=template&id=08516b12&scoped=true"
import script from "./FCInfo.vue?vue&type=script&lang=js"
export * from "./FCInfo.vue?vue&type=script&lang=js"

import "./FCInfo.vue?vue&type=style&index=0&id=08516b12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08516b12"]])

export default __exports__